import RANDOM from "../../UTIL/RANDOM";
import {Howl, Howler } from 'howler';
import Sounds from "./Sounds";
import ARRAY from "../../UTIL/ARRAY";
import LOG, { log } from "../../UTIL/LOG";
 
class SoundChannel
{
    private Sounds      : Sounds;
    private isMulti     : boolean;
    private id          : string;
    private group       : string;
    private current     : any;
    public pool         : any = {};
    private isMuted     : any = false;

    private url         : string = "https://supersnappy.io/artlib/audio/";

    private lastPlayed  : any;
  
    constructor( Sounds:Sounds, id:string, group:string, isMulti:boolean )
    {
        this.Sounds     = Sounds;
        this.isMulti    = isMulti;
        this.id         = id;
        this.group      = group;
    };

    public play( _label:string, vars?:any )
    {
        let label = this.Sounds.get( _label );

        if( this.isMuted )
        {
            if( !this.isMulti ) this.current = label;
            return;
        }

        if( !this.isMulti )
        {
            if( this.current == label ) return;
            this.stopCurrent();
        }
 
        vars            = vars || {};
        this.current    = label;

        vars.loop       = vars.loop || false;

        if( this.id == "voice" ) vars.rate = 1 + RANDOM.decimal( 0.08 );

        let howl : any = this.get( label, vars );
 
        howl.playID = howl.play();

        if( vars.volume ) howl.volume( vars.volume );
 
        if( vars.rate ) howl.rate( vars.rate, howl.playID );

        if( this.group == "music" )
        {
            howl.volume( 0.2 );
            this.fadeIn( howl );
        }

        return howl;
    };
 
    public pause()
    {
        this.lastPlayed = this.current;
        this.stop();
    }

    public resume()
    {
        if( this.lastPlayed ) this.play( this.lastPlayed );
    }
 
    public stop( name?:any )
    {
        if( name )
        {
            if( this.pool[name] ) this.stopSound( this.pool[name] );
            if( this.current == name ) this.current = null;
            return;
        }

        for( name in this.pool ) this.stopSound( this.pool[name] );

        this.current = null;
    }

    public loop( name:string, vars?:any )
    {
        vars        = vars || {};
        vars.loop   = true;

        return this.play( name, vars );
    }

    public playPitch( name:string, vars?:any )
    {
        vars        = vars || {};
 
        return this.play( name, ARRAY.extract( { rate: 1.2 + RANDOM.spectrumDecimal( 0.4 ) }, vars ));
    }
 
    public playPitchSmall( name:string, vars?:any )
    {
        vars        = vars || {};
 
        return this.play( name, ARRAY.extract( { rate: 1 + RANDOM.spectrumDecimal( 0.12) }, vars ));
    }
 
    public mute( bool?:boolean )
    {
        if( this.isMuted == Boolean( bool )) return;

        this.isMuted = Boolean( bool );

        if( !this.current ) return;

        let label       = this.current;

        if( this.isMuted ) 
        {
            this.stopCurrent();
            if( this.group == "music" ) this.current = label;
            return;
        }
    
        if( this.group != "music" ) return;
 
        this.current    = null;

        this.play( label );
    }

     /*============================ 




    PLAY, SEARCH, INDEX




    =============================*/
 
    private get( label:string, vars:any ) : Howl
    {
        this.current = label;
 
        let howl : Howl = this.pool[ label ];

        if( howl ) return howl;

        let isMusic = this.group == "music";
 
        howl = this.pool[ label ] = new Howl(
        {
            src         : [ this.url + this.id + "/" + label + '.mp3' ],
           // html5       : true,
            loop        : isMusic || vars.loop,
            autoplay    : !this.isMuted,
            volume      : isMusic ? 0.2 : 1
            
        }); 
 
        return howl;
    }

    private stopCurrent()
    {
        this.stopSound( this.pool[ this.current ] );

        this.current = null;
    }

    private stopSound( howl:any )
    {   
        if( !howl ) return;
        howl.stop();
        //howl.unload();    
    }
 
    private fadeIn( howl:any, volume?:number )
    {
        howl.fade( 0, volume || 0.2, 1000, howl.playID );
    }

    private fadeOut( howl:any )
    {
        howl.fade( 0.2, 0, 1000, howl.playID );
    }
}

export default SoundChannel;